import React from 'react';

export const UnlockIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="8" width="10" height="7" rx="1.5" />
    <path d="M5.5 8V5.5a2.5 2.5 0 0 1 5 0" />
  </svg>
);
